import { render } from "./AboutUsComponent.vue?vue&type=template&id=7b6b650e&scoped=true"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js"

import "./AboutUsComponent.vue?vue&type=style&index=0&id=7b6b650e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6b650e"]])

export default __exports__